export const ENVIRONMENTS = {
  DEVELOPMENT: "development",
  TEST: "test",
  PRODUCTION: "production",
  EMULATOR: "emulator",
}

export const DISABLE_DEBUG_WIDGET = process.env.REACT_APP_DISABLE_DEBUG_WIDGET === 'true'